import { Dialog, DialogContent, DialogContentText, DialogActions, Button, Box, type ButtonProps } from '@mui/material'
import { type MouseEvent, useActionState, startTransition } from 'react'

type MouseButtonEvent = MouseEvent<HTMLButtonElement>
type Props = {
  open: boolean
  onClose: ()=> void
  message: React.ReactNode
  ok_text: string
  cancel_text: string
  action: (event: MouseEvent<HTMLButtonElement>)=> (void | Promise<void>)
  ok_color?: ButtonProps['color']
  auto_close?: boolean
}
const ConfirmDialog: React.FC<Props> = ({open, onClose, action, message, ok_text, cancel_text, ok_color = 'warning', auto_close = true}) => {
  const [, do_action, is_pending] = useActionState<void, MouseButtonEvent>(async (_, event)=> {
    await action(event)
    if (auto_close) onClose()
  }, undefined)
  return <Dialog
    open={open}
    onClose={onClose}
    // body ではなく内部コンテナでスクロールする設計のため、MUI のスクロールロック（padding-right 補正）は不要
    disableScrollLock
  >
    <DialogContent>
      {typeof message === 'string' ?
        <DialogContentText sx={{whiteSpace: 'pre-wrap'}}>
          {message}
        </DialogContentText>
      :
        message
      }
    </DialogContent>
    <DialogActions>
      <Box sx={{
        display: 'flex', width: '100%', justifyContent: 'space-around'
      }}>
        <Button
          color='inherit' fullWidth
          onClick={onClose}
          disabled={is_pending}
        >
          {cancel_text}
        </Button>
        <Button
          fullWidth
          color={ok_color}
          onClick={e=> {
            startTransition(()=> { do_action(e) })
          }}
          disabled={is_pending}
        >
          {ok_text}
        </Button>
      </Box>
    </DialogActions>
  </Dialog>
}
export default ConfirmDialog